import {
  ChakraPopover,
  ChakraButton as Button,
  ChakraText as Text,
  ChakraLink as Link,
  ChakraHStack as HStack,
  ChakraPopoverTrigger as PopoverTrigger,
  ChakraPopoverContent as PopoverContent,
  ChakraPopoverArrow as PopoverArrow,
  ChakraFlex as Flex,
  chakraUseClipboard as useClipboard,
  Icons,
} from "@airhelp/react-ui-components";
import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { useDeviceSize } from "hooks";
import { useState } from "react";
import { trackClickEvent } from "utils/trackingUtils";

const NEW_CLAIM_EMAIL = "newclaim@airhelp.com";
const BUTTON_ANIMATION_TIME = 1100;

const copied = keyframes`
    0% {
      transform: scale(0.2);
      opacity: 0;
    }
  
    33% {
      transform: scale(1);
      opacity: 1;
    }
  
    100% {
      transform: scale(1.5);
      opacity: 0;
    }
  `;

const CopiedText = styled.span`
  animation: ${copied} ${BUTTON_ANIMATION_TIME}ms linear;
`;

const Popover = ({ triggerElement, content }: { triggerElement: JSX.Element; content: string }) => {
  const { isMobile } = useDeviceSize();
  const popoverTrigger = isMobile ? "click" : "hover";
  return (
    <ChakraPopover placement="top" trigger={popoverTrigger}>
      <PopoverTrigger>{triggerElement}</PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        {content}
      </PopoverContent>
    </ChakraPopover>
  );
};

const ItemForwardBooking = () => {
  const { onCopy } = useClipboard(NEW_CLAIM_EMAIL);
  const { Info } = Icons;
  const [showTextCopied, setShowTextCopied] = useState(false);

  const handleCopyOnClick = () => {
    if (showTextCopied) return;

    trackClickEvent("Hero", "Claimbyemial:copy");
    onCopy();

    setShowTextCopied(true);
    setTimeout(() => {
      setShowTextCopied(false);
    }, BUTTON_ANIMATION_TIME);
  };

  const handleLearnMoreOnClick = () => {
    trackClickEvent("Hero", "Claimbyemial:learnmore");
  };

  return (
    <>
      <Text fontSize="md" fontWeight="medium" mb={5} as="div" textAlign="start">
        Email us your flight booking confirmation to&nbsp;
        <Flex alignItems="center" display={{ base: "flex", md: "inline" }}>
          <Link href={`mailto:${NEW_CLAIM_EMAIL}`}>{NEW_CLAIM_EMAIL}</Link>
          <Popover
            triggerElement={<Info ml={1} color="primary.500" />}
            content="If your flight has been delayed or canceled, you can now check for compensation by simply forwarding one email to
        AirHelp."
          />
        </Flex>
      </Text>
      <HStack justifyContent={{ base: "space-between", md: "flex-end" }} gap={1.5}>
        <Button size={{ base: "s", md: "m" }} onClick={handleCopyOnClick} order={{ base: 0, md: 1 }}>
          {showTextCopied ? <CopiedText>Copied</CopiedText> : "Copy E-mail"}
        </Button>
        <Button
          as="a"
          _visited={{}}
          href="https://www.airhelp.com/en/email-based-claiming/"
          target="_blank"
          size={{ base: "s", md: "m" }}
          height={{ base: "40px", md: "48px" }}
          variant={{ base: "subtle", md: "secondary" }}
          fontWeight={{ base: "normal", md: "medium" }}
          onClick={handleLearnMoreOnClick}
        >
          Learn more
        </Button>
      </HStack>
    </>
  );
};

export default ItemForwardBooking;
